import { campaignAlertsSlice } from '../../campaignAlerts';
import { TapiEndpointFactory } from '../baseQuery';

export const getCampaignAlertsEndpoint: TapiEndpointFactory<'V1CampaignsAlertsDetail'> =
  (builder) =>
    builder.query({
      query: ({ id: campaignId }) => `/campaigns/${campaignId}/alerts`,
      onQueryStarted: async (
        { id: campaignId },
        { dispatch, queryFulfilled }
      ) => {
        try {
          const response = await queryFulfilled;

          dispatch(
            campaignAlertsSlice.actions.campaignAlertsFetched({
              campaignId: campaignId,
              alerts: response.data.data.map((apiCampaignAlert) => ({
                ...apiCampaignAlert.attributes,
                id: `${apiCampaignAlert.attributes.id}-${campaignId}`,
              })),
            })
          );
        } catch (err) {
          console.log('error fetching campaign alerts');
        }
      },
    });
